import React from 'react';
import styled from 'styled-components';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ExclamationRedIcon } from '../Icons';

const StyledFormHelperText = styled(FormHelperText).withConfig({ componentId: 'sc-13sl1by-0' })`
  display: flex;

  & img {
    padding-right: 4px;
    cursor: initial;
  }
`;

type FormHelperTextErrorProps = {
  errorText: string | null | undefined;
};

const FormHelperTextError = ({ errorText }: FormHelperTextErrorProps) => (
  <StyledFormHelperText>
    <ExclamationRedIcon />
    {errorText}
  </StyledFormHelperText>
);

export default FormHelperTextError;
